import { unByKey } from 'ol/Observable';

const LAYER_KEY = 'layer';
const NAME_KEY = 'legend_name';
const LEGEND_KEY = 'legend_url';
const LEGEND_CLICK_HANDLER_KEY = 'legend_click_handler';

class Layer {
	
	constructor(layer) {
		this.layer = layer;
		this.layer.set(LAYER_KEY, this);
	}
	
	getName() {
		return this.layer.get(NAME_KEY);
	}	
	
	setName(name) {
		this.layer.set(NAME_KEY, name);
	}
	
	isVisible() {
		return this.layer.getVisible();
	}
	
	setVisible(visible) {
		this.layer.setVisible(visible);
	}
	
	setOpacity(opacity) {
		this.layer.setOpacity(opacity);
	}
	
	hasLegend(resolution) {
		return this.getLegendUrl(resolution) != null;
	}
	
	getLegendUrl() {
		return this.layer.get(LEGEND_KEY);
	}
	
	setLegendUrl(legendUrl) {
  		this.layer.set(LEGEND_KEY, legendUrl);
  	}
	
	clearLegend() {
		this.setLegendUrl(null);
	}
	
	changed() {
		this.layer.changed();
		console.log("called changed");
	}
	
	addAttribution(attribution) {
		const source = this.layer.getSource();
		if( source ) {
			source.setAttributions(attribution);
		}
	}
	
	addChangeEventHandler(handler) {
		const layerKey = this.layer.on(["change", "change:visible"], (e) => handler());
		const source = this.layer.getSource();
		let sourceKey = null;
		
		if( source ) {
			sourceKey = source.on(["change", "change:params"], (e) => handler());
		}

		return () => {
			unByKey(layerKey);
			if( sourceKey ) {
				unByKey(sourceKey);
			}
		}	
	}
	
	getLegendClickHandler() {
		return this.layer.get(LEGEND_CLICK_HANDLER_KEY);
	}
	
	setLegendClickHandler(handler) {
		if( handler != null ) {
			this.layer.set(LEGEND_CLICK_HANDLER_KEY, handler);
			
			return () => {
				this.layer.set(LEGEND_CLICK_HANDLER_KEY, null);
			}
		}
	}
	
}

export { Layer, NAME_KEY, LAYER_KEY, LEGEND_KEY }